import React from 'react';
import clsx from 'clsx';
import { Colors, Shadows } from '@common/tokens';
import { Text } from '@common/components';

type CardProps = React.PropsWithChildren<{
  title?: string;
  footer?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}>;

export const Card = ({
  title,
  footer,
  className,
  children,
  'data-testid': dataTestId,
}: CardProps) => {
  return (
    <>
      <div className={clsx('wk-card', className)} data-testid={dataTestId}>
        {title && (
          <header className="wk-card-header">
            <Text bold size="lg">
              {title}
            </Text>
          </header>
        )}
        <main className="wk-card-body">{children}</main>
        {footer && <footer className="wk-card-footer">{footer}</footer>}
      </div>
      <style jsx>{`
        .wk-card {
          border-radius: 4px;
          background-color: ${Colors.white};
          border: 1px solid ${Colors.steel};
          box-shadow: ${Shadows.xs};
          width: 100%;
        }
        .wk-card-header {
          padding: 16px;
          background-color: ${Colors.elmHyperlight};
          width: 100%;
        }
        .wk-card-body {
          width: 100%;
          padding: 16px;
        }
        .wk-card-footer {
          width: 100%;
          padding: 16px;
          border-top: 1px solid ${Colors.steel};
        }
      `}</style>
    </>
  );
};
